import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { BRAND } from '../constants/brand';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-24 md:py-28 w-full">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-brand-violet hover:text-slate-900 mb-10 transition-colors"
        >
          <FiArrowLeft />
          Back to home
        </Link>
        <h1 className="font-display text-4xl font-bold text-slate-900 mb-2">Terms of Service</h1>
        <p className="text-slate-500 text-sm mb-10">Last updated: {new Date().getFullYear()}</p>

        <div className="prose prose-sm max-w-none text-slate-600 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Agreement</h2>
            <p>
              By accessing {BRAND.name}’s website or engaging our IT solutions and professional
              services, you agree to these Terms. If you do not agree, do not use our services.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Services</h2>
            <p>
              Specific scope, fees, and deliverables for any engagement are defined in a separate
              statement of work or agreement. Website content is for general information only.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Acceptable use</h2>
            <p>You agree not to misuse our systems, attempt unauthorized access, or use our services for unlawful purposes.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, {BRAND.name} is not liable for indirect or
              consequential damages arising from use of the website or services. Some jurisdictions
              do not allow certain limitations; in those cases, our liability is limited to the
              maximum permitted by law.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Contact</h2>
            <p>
              <a href={`mailto:${BRAND.contact.email}`} className="text-brand-violet hover:underline">
                {BRAND.contact.email}
              </a>
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
